import { MEDIA_QUERY, pxToRem } from '@bucketplace/design-system';
import { Modal } from '@bucketplace/design-system/bds';
import styled from '@emotion/styled';
import React from 'react';

import { OHS_HOST, STORE_HOST } from '@/common';
import { useAutoChangeComponent } from '@/utils';

interface EndModalProps {
  end: Date | string | number;
  title: string;
  contents: string;
  redirectTarget?: 'home' | 'store';
}

const modalButtonInfo = {
  home: {
    label: '홈으로 이동하기',
    href: `${OHS_HOST}`,
  },
  store: {
    label: '쇼핑하러 가기',
    href: `${STORE_HOST}`,
  },
};

export const EndModal = ({
  end,
  title,
  contents,
  redirectTarget = 'home',
}: EndModalProps): React.ReactElement | null => {
  const endTime = new Date(end);
  const { label, href } = modalButtonInfo[redirectTarget];
  const autoChange = useAutoChangeComponent(endTime);

  return autoChange(
    null,
    <Modal
      width={600}
      header={{
        title,
      }}
    >
      {contents.split('\\n').map((content, index) => (
        <div key={index}>{content}</div>
      ))}
      <Anchor href={href}>{label}</Anchor>
    </Modal>,
  );
};

const Anchor = styled.a`
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: ${pxToRem(4)};
  font-weight: 400;
  color: white;
  line-height: 1.25rem;
  min-height: ${pxToRem(32)};
  ${({ theme }) => `
    background-color: ${theme.content.primary1.basic};
  `}
  word-break: keep-all;
  margin-top: ${pxToRem(10)};
  margin-bottom: ${pxToRem(10)};
  width: 40%;
  ${MEDIA_QUERY.max(
    'mobile',
    `
    width: ${pxToRem(150)};
  `,
  )}
`;
